var $99b345867a868892$exports = {};
$99b345867a868892$exports = {
    "backButton": (args)=>`Gr\u{12F}\u{17E}ti \u{12F} ${args.prevMenuButton}`,
    "moreActions": `Daugiau veiksm\u{173}`,
    "unavailable": `Nepasiekiama, nor\u{117}dami gauti daugiau informacijos, i\u{161}skleiskite`
};


export {$99b345867a868892$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
